import React from 'react';
/**
 * Class to handle the pagination of the related category articles.
 */
export default class Pagination extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    /**
     * Creates the aria label for active and non-active pagination links.
     * @param {Number} pageNumber The current page number.
     * @param {Number} pageCount The page count.
     * @returns The aria label string based on the page link being active or not.
     */
    getAriaLabel(pageNumber, pageCount) {
        const label = `Page ${pageNumber} of ${pageCount}`;
        const currentlyActive = '- Currently Active';

        return this.props.currentPage === pageNumber ? `${label} ${currentlyActive}` : label;
    }

    /**
     * Checks the current page against the data page number on the HTML element. 
     * If a match then the active class is applied to the pagination link.
     * @param {Number} pageNumber Page number of the element being checked.
     */
    getPaginationClass(pageNumber) {
        const paginationPageClass = 'pagination__page';
        const activeClass = 'pagination__page--active';

        return this.props.currentPage === pageNumber ? `${paginationPageClass} ${activeClass}` : paginationPageClass;
    }

    /**
     * Propogates the click event target up to the related articles handler.
     * @param {MouseEvent} e 
     */
    handleClick(e) {
        this.props.handlePageClick(e.target);
        e.preventDefault();
    }

    /**
     * Renders the pagination component.
     */
    render() {
        const paginationBlock = [];

        if (this.props.currentPage > 1) {
            paginationBlock.push(
                <a className="pagination__previous"
                href="#"
                data-page-num={this.props.currentPage - 1}
                aria-label='Previous page'
                onClick={this.handleClick}
                key={'pagination__previous'}></a>
            );
        }

        if (this.props.isMobile) {
            if (this.props.pageCount <= 3) {
                //Display 1 - N
                for(let i = 1; i <= this.props.pageCount; i++) {
                    paginationBlock.push(
                        <a className={this.getPaginationClass(i)} 
                        data-page-num={i} 
                        href="#" 
                        aria-label={this.getAriaLabel(i, this.props.pageCount)} 
                        onClick={this.handleClick}
                        key={`pagination__${i}`}>{i}</a>
                    );
                }
            }
            else if (this.props.currentPage > 1 && this.props.currentPage < this.props.pageCount ) {
                //Display n-1 n n+1
                for(let i = this.props.currentPage - 1; i <= this.props.currentPage + 1; i++) {
                    paginationBlock.push(
                        <a className={this.getPaginationClass(i)} 
                        data-page-num={i} 
                        href="#" 
                        aria-label={this.getAriaLabel(i, this.props.pageCount)}
                        onClick={this.handleClick}
                        key={`pagination__${i}`}>{i}</a>
                    );
                }
            }
            else if (this.props.currentPage >= this.props.pageCount - 1) {
                //Display pc-2 pc-1 pageCount
                for(let i = this.props.pageCount - 2; i <= this.props.pageCount; i++){
                    paginationBlock.push(
                        <a className={this.getPaginationClass(i)} 
                        data-page-num={i} 
                        href="#" 
                        aria-label={this.getAriaLabel(i, this.props.pageCount)}
                        onClick={this.handleClick}
                        key={`pagination__${i}`}>{i}</a>
                    );
                }
            }
            else if (this.props.currentPage <= 2) {
                //Display 1 2 3
                for(let i = 1; i <= 3; i++){
                    paginationBlock.push(
                        <a className={this.getPaginationClass(i)} 
                        data-page-num={i} 
                        href="#" 
                        aria-label={this.getAriaLabel(i, this.props.pageCount)}
                        onClick={this.handleClick}
                        key={`pagination__${i}`}>{i}</a>
                    );
                }
            }
            else {
                //Do nothing
            }
        }
        else {
            if (this.props.pageCount <= 9) {
                //Display 1 - N
                for(let i = 1; i <= this.props.pageCount; i++) {
                    paginationBlock.push(
                        <a className={this.getPaginationClass(i)} 
                        data-page-num={i} 
                        href="#" 
                        aria-label={this.getAriaLabel(i, this.props.pageCount)} 
                        onClick={this.handleClick}
                        key={`pagination__${i}`}>{i}</a>
                    );
                }
            }
            else if (this.props.currentPage > 5 && this.props.currentPage < this.props.pageCount - 5 ) {
                //Display 1 ... n-2 n-1 n n+1 n+2 ... pageCount
                paginationBlock.push(
                    <a className="pagination__page" 
                    data-page-num="1" 
                    href="#" 
                    aria-label={`Page 1 of ${this.props.pageCount}`}
                    onClick={this.handleClick}
                    key={`pagination__1`}>1</a>,
                    <span className="pagination__ellipsis" key={'pagination__ellipsis-left'}>&hellip;</span>
                );
    
                for(let i = this.props.currentPage - 2; i <= this.props.currentPage + 2; i++) {
                    paginationBlock.push(
                        <a className={this.getPaginationClass(i)} 
                        data-page-num={i} 
                        href="#" 
                        aria-label={this.getAriaLabel(i, this.props.pageCount)}
                        onClick={this.handleClick}
                        key={`pagination__${i}`}>{i}</a>
                    );
                }
                
                paginationBlock.push(
                    <span className="pagination__ellipsis" key={'pagination__ellipses-right'}>&hellip;</span>,
                    <a className="pagination__page" 
                    data-page-num={this.props.pageCount} 
                    href="#"
                    aria-label={`Page ${this.props.pageCount} of ${this.props.pageCount}`}
                    onClick={this.handleClick}
                    key={`pagination__${this.props.pageCount}`}>{this.props.pageCount}</a>
                );
            }
            else if (this.props.currentPage <= 5) {
                //Display 1 2 3 4 5 6 7 ... pageCount
                for(let i = 1; i <= 7; i++){
                    paginationBlock.push(
                        <a className={this.getPaginationClass(i)} 
                        data-page-num={i} 
                        href="#" 
                        aria-label={this.getAriaLabel(i, this.props.pageCount)}
                        onClick={this.handleClick}
                        key={`pagination__${i}`}>{i}</a>
                    );
                }
                paginationBlock.push(
                    <span className="pagination__ellipsis" key={'pagination__ellipses-right'}>&hellip;</span>,
                    <a className="pagination__page" 
                    data-page-num={this.props.pageCount} 
                    href="#" 
                    aria-label={`Page ${this.props.pageCount} of ${this.props.pageCount}`}
                    onClick={this.handleClick}
                    key={`pagination__${this.props.pageCount}`}>{this.props.pageCount}</a>
                );
            }
            else if (this.props.currentPage >= this.props.pageCount - 5) {
                //Display 1 ... pc-6 pc-5 pc-4 pc-3 pc-2 pc-1 pageCount
                paginationBlock.push(
                    <a className="pagination__page" 
                    data-page-num="1" 
                    href="#" 
                    aria-label={`Page 1 of ${this.props.pageCount}`}
                    onClick={this.handleClick}
                    key={`pagination__1`}>1</a>,
                    <span className="pagination__ellipsis" key={'pagination__ellipsis-left'}>&hellip;</span>
                );
                for(let i = this.props.pageCount - 6; i <= this.props.pageCount; i++){
                    paginationBlock.push(
                        <a className={this.getPaginationClass(i)} 
                        data-page-num={i} 
                        href="#" 
                        aria-label={this.getAriaLabel(i, this.props.pageCount)}
                        onClick={this.handleClick}
                        key={`pagination__${i}`}>{i}</a>
                    );
                }
            }
            else {
                //Do nothing
            }
        }

        if (this.props.currentPage !== this.props.pageCount && this.props.pageCount > 1) {
            paginationBlock.push(
                <a className="pagination__next"
                href="#"
                data-page-num={this.props.currentPage + 1}
                aria-label='Next page'
                onClick={this.handleClick}
                key={'pagination__next'}></a>
            )
        }

        return (
            <div className="pagination">
                {paginationBlock}
            </div>
        );
    }
}